import { create } from 'zustand'

import type { Post } from '@/api/types'

interface UiState {
  composerOpen: boolean
  /** 打开发帖弹窗时的上下文：回复谁 / 引用谁 */
  composerReplyTo: Post | null
  composerQuoteOf: Post | null

  openComposer: (options?: { replyTo?: Post | null; quoteOf?: Post | null }) => void
  closeComposer: () => void
}

export const useUiStore = create<UiState>((set) => ({
  composerOpen: false,
  composerReplyTo: null,
  composerQuoteOf: null,

  openComposer: (options) =>
    set({
      composerOpen: true,
      composerReplyTo: options?.replyTo ?? null,
      composerQuoteOf: options?.quoteOf ?? null,
    }),

  closeComposer: () => set({ composerOpen: false, composerReplyTo: null, composerQuoteOf: null }),
}))
